import { render, staticRenderFns } from "./share.vue?vue&type=template&id=3a84c65f&scoped=true"
import script from "./share.vue?vue&type=script&lang=ts"
export * from "./share.vue?vue&type=script&lang=ts"
import style0 from "./share.vue?vue&type=style&index=0&id=3a84c65f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a84c65f",
  null
  
)

export default component.exports